import {Component, OnInit} from '@angular/core';
import {SteelProfileService} from '../steel-profile.service';
import {SteelProfile} from '../steel-profile';

@Component({
    selector: 'app-steel-profile-list',
    templateUrl: './steel-profile-list.component.html',
    styleUrls: ['./steel-profile-list.component.css']
})
export class SteelProfileListComponent implements OnInit {
    profiles: SteelProfile[];

    constructor(private profileService: SteelProfileService) {
    }

    ngOnInit() {
        this.profileService.getAll().subscribe((profiles) => {
            this.profiles = profiles;
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile-list/steel-profile-list.component.ts